import { Handle, Position } from '@xyflow/react';

interface MainSchemaTerminalNodeData {
  terminal_instance_id: number;
  terminal_block_name: string;
  terminal_position_in_block: number;
  terminal_contact_id: number;
  terminal_opposite_contact_id?: number;
  terminal_contact_label?: string;
  terminal_opposite_contact_label?: string;
  cable_instance_id: number;
  cable_contact_id: number;
  connection_id: number;
      // isConnecting?: boolean; - TEMPORARILY COMMENTED
}

interface MainSchemaTerminalNodeProps {
  data: MainSchemaTerminalNodeData;
}

/**
 * MAIN SCHEMA: Terminal block node component for auto-placed terminals
 * Features:
 * - Top contact (from terminal_internal_connections)
 * - Terminal block name (e.g. XT1)
 * - Position in block
 * - Bottom contact (connected to cable)
 */
const handleCenterStyle: React.CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  bottom: 'auto',
  right: 'auto',
  transform: 'translate(-50%, -50%)',
  width: 0,
  height: 0,
  minWidth: 0,
  minHeight: 0,
  padding: 0,
  margin: 0,
  border: 0,
  background: 'transparent',
};

export default function MainSchemaTerminalNode({ data }: MainSchemaTerminalNodeProps) {
  const {
    terminal_block_name,
    terminal_position_in_block,
    terminal_contact_id,
    terminal_opposite_contact_id,
    terminal_contact_label,
    terminal_opposite_contact_label,
    // isConnecting = false - TEMPORARILY COMMENTED
  } = data;

  return (
    <div 
      className="bg-white border-2 border-blue-500 rounded shadow-lg select-none"
      style={{ width: 36, minHeight: '120px' }}
    >
      {/* TOP contact - верхний контакт для соединения с другими устройствами */}
      <div className="flex flex-col justify-center items-center px-1 py-1">
        <div className="w-3 h-3 rounded-full border-2 border-blue-500 bg-white relative">
          <Handle type="target" position={Position.Top} id={`${terminal_opposite_contact_id || terminal_contact_id}-top-target`} className="schema-target-handle" style={handleCenterStyle} />
          <Handle type="source" position={Position.Top} id={`${terminal_opposite_contact_id || terminal_contact_id}-top-source`} className="schema-source-handle" style={handleCenterStyle} />
        </div>
        {/* Подпись верхнего контакта */}
        <div className="text-center font-bold text-blue-600 mt-0.5" style={{ fontSize: '8px' }}>
          {terminal_opposite_contact_label || 'UP'}
        </div>
      </div>

      {/* Terminal block name */}
      <div className="py-1 text-center border-b border-gray-200" style={{ paddingLeft: '0.2rem', paddingRight: '0.2rem' }}>
        <div className="font-bold text-blue-700" style={{ fontSize: '11px' }}>
          {terminal_block_name}
        </div>
        <div className="text-gray-600" style={{ fontSize: '15px' }}>
          {terminal_position_in_block}
        </div>
      </div>

      {/* Position in block - removed as it's now part of the title */}

      {/* BOTTOM contact - нижний контакт соединенный с кабелем */}
      <div className="flex flex-col justify-center items-center px-1 py-1 border-t border-gray-200">
        {/* Подпись нижнего контакта */}
                            {terminal_contact_label && (
                      <div className="text-center font-bold text-blue-600 mb-0.5" style={{ fontSize: '8px' }}>
                        {terminal_contact_label}
                      </div>
                    )}
        <div className="w-3 h-3 rounded-full border-2 border-blue-500 bg-white relative">
          <Handle type="source" position={Position.Bottom} id={`${terminal_contact_id}-bottom-source`} className="schema-source-handle" style={handleCenterStyle} />
        </div>
      </div>
    </div>
  );
} 